function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_69720",
  transform: "translate(-20 -20)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_148712",
  d: "M39.53,42.895,37.637,48.8a.219.219,0,0,0,.205.29h.53a.219.219,0,0,0,.21-.158l.3-.947H41.47l-.036-.058.325,1a.219.219,0,0,0,.21.158h.53a.219.219,0,0,0,.21-.287L40.816,42.9a.221.221,0,0,0-.21-.158h-.871a.219.219,0,0,0-.205.155Zm-.336,4.146L40.17,44l.984,3.04Z",
  transform: "translate(-14.845 -19.153)",
  fill: "#7e27e4"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_13467",
  width: 0.947,
  height: 6.348,
  rx: 0.473,
  transform: "translate(29.308 23.589)",
  fill: "#7e27e4"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_148713",
  d: "M27.456,32.3H22.865a1.287,1.287,0,0,1-1.287-1.287V22.865a1.287,1.287,0,0,1,1.287-1.287h8.153A1.287,1.287,0,0,1,32.3,22.865v4.076a.327.327,0,0,0,.334.316h0a1.735,1.735,0,0,1,.775.18.325.325,0,0,0,.473-.3V22.865A2.865,2.865,0,0,0,31.018,20H22.865A2.865,2.865,0,0,0,20,22.865v8.153a2.865,2.865,0,0,0,2.865,2.865h5.253a.327.327,0,0,0,.232-.557,2.545,2.545,0,0,1-.585-.8A.333.333,0,0,0,27.456,32.3Z",
  fill: "#7e27e4"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_148714",
  d: "M84.094,80.137l1.429-.563a.158.158,0,0,0,0-.293l-1.429-.563A1.989,1.989,0,0,1,82.975,77.6l-.563-1.42a.158.158,0,0,0-.293,0l-.563,1.42a1.985,1.985,0,0,1-1.118,1.118l-1.42.563a.158.158,0,0,0,0,.293l1.42.563a1.985,1.985,0,0,1,1.118,1.118l.563,1.42a.157.157,0,0,0,.293,0l.563-1.42A1.989,1.989,0,0,1,84.094,80.137Z",
  transform: "translate(-49.623 -47.233)",
  fill: "#7e27e4"
}));

function SvgAi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 15.544",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.d139113b.svg";
export { ForwardRef as ReactComponent };